import { gsap, ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

export function haloStructure(element: Element): void {
  let mm = gsap.matchMedia()
  const marquees = [...Array.from(element.querySelectorAll('.js-inner'))] as HTMLElement[]

  mm.add('(min-width: 769px)', () => {
    const animationTl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',
        end: 'center center',
        scrub: 1,
        invalidateOnRefresh: true
      }
      // onComplete: () =>
      // clear inline styles after complete
      // gsap.set([], {
      // clearProps: 'all',
      // }),
    })

    ScrollTrigger.create({
      trigger: element,
      start: 'top 50%',
      end: 'bottom 50%',
      onEnter: () => {
        gsap.to(marquees, {
          opacity: 0.6,
          ease: 'expo.out',
          duration: 1.2
        })
      },
      onEnterBack: () => {
        gsap.to(marquees, {
          opacity: 0.6,
          ease: 'expo.out',
          duration: 1.2
        })
      },
      onLeave: () => {
        gsap.to(marquees, {
          opacity: 0.25,
          ease: 'expo.out',
          duration: 1.2
        })
      },
      onLeaveBack: () => {
        gsap.to(marquees, {
          opacity: 0.25,
          ease: 'expo.out',
          duration: 1.2
        })
      }
    })

    animationTl
      .fromTo(
        marquees[0],
        { xPercent: -150 },
        {
          xPercent: 0,
          ease: 'linear'
        }
      )
      .fromTo(
        marquees[1],
        { xPercent: 105 },
        {
          xPercent: 0,
          ease: 'linear'
        },
        0
      )
  })
}
